import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestOrganizations} from "../../../redux/Actions/organizations.actions";
import {
  getOrganizationList,
  getOrgsPaginationUrls,
  getTotalCount,
} from "../../../redux/Selectors/organization.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {orgsListURL} from "./organizationTable.constants";

export const useFetchOrganizations = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestOrganizations());
  };

  const refetch = () => {
    dispatch(requestOrganizations(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useOrganizationTableData = () => {
  const dispatch = useDispatch();
  const {freshFetch} = useFetchOrganizations();
  const {setPageUrl} = usePageURLContext();
  const organizations = useSelector(getOrganizationList);
  const orgUrls = useSelector(getOrgsPaginationUrls);
  const totalCount = useSelector(getTotalCount);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    const url = currentPage < page ? orgUrls?.nextUrl : orgUrls?.prevUrl;
    dispatch(requestOrganizations(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(orgsListURL, tokens);
      dispatch(requestOrganizations(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };
  return {handleSearch, organizations, paginationConfig, totalCount};
};
